/**
 * アプリケーション設定ファイル
 * 各種アニメーションや機能の設定値を集約
 */

// GSAPアニメーション設定
export const GSAP_CONFIG = {
  basicToggleActions: 'play none none none',
  basicEase: 'power4.inOut',
  devicePC: '(min-width: 1024px)',
  scrollTriggerStart: 'top 100%', // アニメーション開始位置（100%で要素がビューポートに入る前に開始）
};

// ローディングアニメーション設定
export const LOADING_CONFIG = {
  showInterval: 24 * 60 * 60 * 1000, // 24時間（ミリ秒）
  storageKey: 'lastLoadingShown',
};

// Splideスライダー設定
export const SPLIDE_CONFIG = {
  mv: {
    type: 'fade',
    arrows: false,
    pagination: false,
    autoplay: true,
    rewind: true,
    interval: 10000,
    speed: 1000,
    easing: 'linear',
  },
};

// スライドアニメーション設定
export const SLIDE_CONFIG = {
  zoomDuration: 10,
  switchInterval: 6000, // 6秒間隔でスライド切り替え
};

// トランジション設定
export const TRANSITION_CONFIG = {
  duration: 0.6,
  ease: 'power2.inOut',
  logoFadeDuration: 0.5,
};

// ヘッダー設定
export const HEADER_CONFIG = {
  scrollTriggers: {
    mvTrigger: {
      trigger: '#mv',
      start: 'bottom top',
    },
    topTrigger: {
      trigger: 'body',
      end: 'top+=100px top',
    },
  },
}; 
